import { render } from "./VehicleWithdrawal.vue?vue&type=template&id=0326eaca"
import script from "./VehicleWithdrawal.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawal.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
